<template>
    <b-modal v-model="show" title="АНАЛОГ СОЗЛАШ ПАРАМЕТР" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
                        <v-select
                                label="label"
                                v-model="province"
                                :filterable="false"
                                :options="provinces"
                                @search="onProvinceSearch"
                                @search:focus="onProvinceFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.province.id.$error">
                            {{$t("realEstate.validation.province")}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("realEstate.field.region")}} </label>
                        <v-select label="label"
                                :options="regions"
                                v-model="region"
                                :filterable="false"
                                @search="onRegionSearch"
                                @search:focus="onRegionFocus"
                                @change="onRegionChange"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                      <label>{{$t("newRealEstate.field.plus.mfy")}}</label>
                      <v-select v-model="mfy" label="name"
                                :options="mfyList"
                                :filterable="false"
                                @search="mfySearch"
                                @search:focus="mfyFocus"
                      >
                        <template slot="option" slot-scope="option" v-if="option && option.name">
                          <div v-html="option.name"></div>
                        </template>
                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                      </v-select>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save" :disabled="processing">
                {{$t('action.refresh')}}
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="show = false" :disabled="processing">
              {{$t('action.cancel')}}
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';

    export default {
        name: "AnalogSettingEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                filterMfy: initFilterModel(),
                provinces: [],
                regions: [],
                mfyList: [],
                province: null,
                region: null,
                mfy: null
            }
        },
        validations() {
            return {
              province: {
                id: {
                  required
                }
              }
            }
        },
        methods: {
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                const vm = this;

              this.$swal({
                title: 'Янгилашни амалга оширасизми?',
                text: 'Янгилаш учун "Тасдиқлаш" кнопкасини босинг',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#78b414',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Тасдиқлаш',
                cancelButtonText: 'Бекор қилиш'
              }).then((result) => {
                if (result.value) {
                  this.processing = true;
                  this.$http.post('analog-setting/search-to-create', {province: this.province, region: this.region, mfy: this.mfy})
                      .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                          vm.show = false;
                          this.$emit('change');
                          this.province = null
                          this.region = null
                          this.mfy = null
                        }
                        vm.processing = false;
                      }, err => {
                        vm.processing = false;
                        console.log(err);
                      });
                }
              })
            },
            getAsMaps(result) {
              if (result && result.data && result.data.length > 0) {
                return result.data.map(d => {
                  d.label = d.name;
                  return d;
                })
              }
              return [];
            },
            onProvinceFocus() {
                this.provinces = [];
                this.filterProvince.search = '';
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionChange() {
                if (this.mfy && this.mfy.regionCode !== this.region.code) {
                  this.mfy = null
                }
            },
            mfyFocus() {
              this.mfyList = [];
              if (!this.mfy) {
                this.filterMfy.search = '';
              }

              this.filterMfy.code = (this.region && this.region.code) ? this.region.code : "";
              this.$http.post('/mfy/search', this.filterMfy)
                  .then(res => {
                    this.mfyList = res.data.data;
                  }, err => {
                    console.log(err);
                  });
            },
            mfySearch(searchTxt, loading) {
              loading(true);
              this.mfyList = [];
              this.filterMfy.search = searchTxt;
              this.filterMfy.code = (this.region && this.region.code) ? this.region.code : "";
              this.$http.post('/mfy/search', this.filterMfy)
                  .then(res => {
                    this.mfyList = res.data.data;
                    loading(false);
                  }, err => {
                    console.log(err);
                  });
            }
        },
        created() {
           this.filterProvince.page.size = 1000;
           this.filterRegion.page.size = 1000;

           this.$eventBus.$on('showAnalogSettingCalculateUpdateModal', (data) => {
               if (data) {
                 console.log('data = ', data)
               }
               this.show = true;
           });
        }
    }
</script>

<style scoped>

</style>